import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Search } from "lucide-react";
import { NeuInput } from "../../components/neu/Neu";
import { CompanyCard } from "./CompanyCard";

const match = (company, q) =>
  [company.serial, company.name, company.name_ar, company.slug, company.contact_email]
    .filter(Boolean)
    .some((value) => String(value).toLowerCase().includes(q));

// قائمة الشركات مع بحث بالرقم التسلسلي أو الاسم أو البريد.
export const CompanyList = ({ companies, reload }) => {
  const { t } = useTranslation();
  const [query, setQuery] = useState("");
  const rows = useMemo(() => {
    const q = query.trim().toLowerCase();
    return q ? companies.filter((company) => match(company, q)) : companies;
  }, [companies, query]);

  return (
    <div className="grid gap-4">
      <div className="relative">
        <Search className="absolute top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground ltr:left-4 rtl:right-4" />
        <NeuInput
          className="ltr:pl-10 rtl:pr-10"
          placeholder={t("platform.companySearch")}
          data-testid="company-search"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />
      </div>
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3" data-testid="company-list">
        {rows.map((company) => (
          <CompanyCard key={company.id} company={company} reload={reload} />
        ))}
      </div>
      {rows.length ? null : (
        <p className="text-xs text-muted-foreground" data-testid="company-search-empty">
          {t("platform.companySearchEmpty")}
        </p>
      )}
    </div>
  );
};
